export default __webpack_public_path__ + "static/media/Mercenary's Gauntlets of the Roaring Jungle.afcfd8dd.jpg";